import SelectCalendarState from './schema/SelectCalendarState';
import { createStore } from 'satcheljs';

const defaultSelectCalendarsStore: SelectCalendarState = {
    numberOfLinkedCalendarsSelected: 0,
};

export const getStore = createStore<SelectCalendarState>(
    'selectCalendarsStore',
    defaultSelectCalendarsStore
);

export default getStore;
